import { WebProjectItemModel } from "./types";

export interface TechUsage {
  name: string;
  projects: WebProjectItemModel[];
}

// Every tech in the Hygraph techStack fields, most-used first
export const getTechUsage = (projects: WebProjectItemModel[]): TechUsage[] => {
  const usage = new Map<string, TechUsage>();
  projects.forEach((project) => {
    (project.techStack || []).forEach((rawName) => {
      const name = rawName.trim();
      if (!name) return;
      const key = name.toLowerCase();
      const entry = usage.get(key) || { name, projects: [] };
      entry.projects.push(project);
      usage.set(key, entry);
    });
  });
  return Array.from(usage.values()).sort(
    (a, b) =>
      b.projects.length - a.projects.length || a.name.localeCompare(b.name)
  );
};

const getYear = (date: string | null) => {
  if (!date) return null;
  const year = new Date(date).getFullYear();
  return Number.isNaN(year) ? null : year;
};

export const getProjectStats = (projects: WebProjectItemModel[]) => {
  const years = projects
    .map((project) => getYear(project.dateCompleted))
    .filter((year): year is number => year !== null);
  return {
    total: projects.length,
    featured: projects.filter((project) => project.important).length,
    techCount: getTechUsage(projects).length,
    firstYear: years.length ? Math.min(...years) : null,
    latestYear: years.length ? Math.max(...years) : null,
  };
};
